'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var background = _ref.background,
      foreground = _ref.foreground,
      styles = _ref.styles;
  var rhythm = _ref2.rhythm,
      colors = _ref2.colors;

  var defaultStyles = {
    root: {
      position: 'relative',
      marginBottom: rhythm(0.5),
      backgroundColor: background && colors[background],
      color: foreground && colors[foreground]
    },

    icon: {
      position: 'absolute',
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)',
      pointerEvents: 'none'
    },

    input: {
      display: 'block',
      width: '100%',
      height: rhythm(2),
      paddingLeft: rhythm(1.5),
      borderBottom: '1px solid ' + colors.shade + ' !important'
    }
  };

  return (0, _merge2.default)(defaultStyles, styles);
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/filter/styles.js
// module id = 821
// module chunks = 0